import { FC } from 'react';
import { ProgressSpinner } from 'primereact/progressspinner';
import classNames from 'classnames';
import styles from './LoadingSpinner.module.scss';

interface LoadingSpinnerProps {
  className?: string;
  size?: 'tiny';
  spinnerClassName?: string;
}

const LoadingSpinner: FC<LoadingSpinnerProps> = ({
  className,
  size,
  spinnerClassName,
}) => {
  return (
    <div
      className={classNames(
        styles.spinnerContainer,
        className,
        size === 'tiny' && styles.tinyContainer
      )}
    >
      <ProgressSpinner
        className={classNames(
          styles.spinner,
          size === 'tiny' && styles.tiny,
          spinnerClassName
        )}
      />
    </div>
  );
};

export default LoadingSpinner;
